<template>
    <div>
        <l-marker :lat-lng="latLng" @ready="$emit('ready', $event)" :visible="isVisible" @click="$emit('click')">
            <l-icon :icon-anchor="isPoint ? [20, 41] : [4, 4]" :class-name="isPoint
                ? Object.entries(iconClasses)
                    .filter(([cls, x]) => x)
                    .map(([cls]) => cls)
                    .join(' ')
                : ''
                ">
                <slot name="icon" />
            </l-icon>
            <l-popup v-if="popupContent || $slots.popup" :content="popupContent" :options="{
                closeButton: false,
                className: 'popup-content',
                autoPan: false,
                autoClose: false
            }">
                <slot name="popup" />
            </l-popup>
        </l-marker>
        <l-polyline v-if="this.connectTo" color="#37474F" :lat-lngs="[latLng, this.connectTo]"
            :dashArray="[4, 8]"></l-polyline>
    </div>
</template>

<script>
import { LIcon, LPopup, LMarker, LPolyline } from 'vue2-leaflet'
import { mapGetters } from 'vuex'
export default {
    components: {
        LIcon,
        LPopup,
        LMarker,
        LPolyline,
    },
    props: {
        latLng: {
            // [lat, lng]
            type: Array,
            required: true,
        },
        device: {
            type: Object,
            default: () => { },
        },
        visible: {
            type: Boolean,
            default: true,
        },
        popupContent: {
            type: String,
            default: '',
        },
        point: {
            type: Object,
            default: () => ({}),
        },
        isMeta: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        connectTo: {
            type: Array,
            // required: true,
        },
    },
    data() {
        return {
            polyline: {
                color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
                weight: 3,
                opacity: 0.8,
            },
            latLngHistory: [[0, 0]],
        }
    },
    computed: {
        ...mapGetters(['isPlaybackReady']),
        trackpointsIds() {
            if (this.point.location) {
                return Object.values(this.point.trackpoints)
            }
            return []
        },
        isPoint() {
            return Boolean(this.point.location)
        },
        isVisible() {
            if (
                !this.isPlaybackReady ||
                (this.isPlaybackReady && this.isPoint)
            ) {
                return this.visible
            }
            return false
        },
        // Classes from map competition point.
        iconClasses() {
            return {
                marker: true,
                'marker--with-icons': true,
                'marker--disabled': this.disabled,
                'marker--red': this.isMeta && !this.disabled,
                'w': this.trackpointsIds.length >= 1,
            }
        },
    },
    watch: {
        latLng: {
            deep: true,
            handler() {
                this.$forceUpdate()
            },
        },
    },
}
</script>
<style lang="scss">
.w {
    width: unset !important;
}

.marker {
    background-color: $slate-two;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    &--red {
        background-image: linear-gradient(to left,
                $red-orange 100%,
                $pinky-red 1%);
    }

    &--disabled {
        background-color: $bluish-grey;
    }

    &--with-icons {
        display: flex !important;
        padding: 4px;
        width: unset;
        height: unset !important;
        box-sizing: unset;
    }
}
</style>
